// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import { type Node } from 'react';

import { type UniversalTopbarProps } from '../UniversalTopbar';

type NotificationsRendererProps = {
  currentUrl: string,
  isLoggedIn: boolean,
  renderNotifications: UniversalTopbarProps => Node,
};

type ShouldRender = NotificationsRendererProps => boolean;

// This is a function that *makes* a render function. The reason for
// that is so the render function has access to `NotificationsRendererProps`
// which is necessary in some circumstances.
type MakeRenderNotifications = NotificationsRendererProps => any => Node;

type RendererConfig = {
  shouldRender: ShouldRender,
  makeRenderer: MakeRenderNotifications,
};

const renderDefaultNotifications: RendererConfig = {
  shouldRender: (renderProps: NotificationsRendererProps) => {
    return renderProps.isLoggedIn;
  },
  makeRenderer: (renderProps: NotificationsRendererProps) => (
    props: UniversalTopbarProps
  ) => {
    return renderProps.renderNotifications(props);
  },
};

const renderNothing: RendererConfig = {
  shouldRender: (renderProps: NotificationsRendererProps) => {
    return (
      !renderProps.isLoggedIn || renderProps.currentUrl.includes('/onboarding')
    );
  },
  makeRenderer: () => () => {
    return null;
  },
};

// Order-sensitive array of configurations to render notifications.
// The first one whose `shouldRender` returns `true` is used.
const configs: Array<RendererConfig> = [
  renderNothing,
  renderDefaultNotifications,
];

// Loop through `configs` to find the one that `shouldRender`,
// then return the renderer for it.
const findNotificationsRenderer = (renderProps: NotificationsRendererProps) => {
  const foundConfig = configs.find((config: RendererConfig) => {
    return config.shouldRender(renderProps);
  });
  return foundConfig && foundConfig.makeRenderer(renderProps);
};

export default findNotificationsRenderer;
